import { createDropdownOption, generateId } from 'utils/helpers';
import { UNIT_VALUES } from 'utils/relativeDateTime';

export const SECOND = createDropdownOption(UNIT_VALUES.second, 'Second', generateId());
export const SECONDS = createDropdownOption(UNIT_VALUES.second, 'Seconds', generateId());

export const MINUTE = createDropdownOption(UNIT_VALUES.minute, 'Minute', generateId());
export const MINUTES = createDropdownOption(UNIT_VALUES.minute, 'Minutes', generateId());

export const HOUR = createDropdownOption(UNIT_VALUES.hour, 'Hour', generateId());
export const HOURS = createDropdownOption(UNIT_VALUES.hour, 'Hours', generateId());

export const DAY = createDropdownOption(UNIT_VALUES.day, 'Day', generateId());
export const DAYS = createDropdownOption(UNIT_VALUES.day, 'Days', generateId());

export const WEEK = createDropdownOption(UNIT_VALUES.week, 'Week', generateId());
export const WEEKS = createDropdownOption(UNIT_VALUES.week, 'Weeks', generateId());

export const MONTH = createDropdownOption(UNIT_VALUES.month, 'Month', generateId());
export const MONTHS = createDropdownOption(UNIT_VALUES.month, 'Months', generateId());

export const YEAR = createDropdownOption(UNIT_VALUES.year, 'Year', generateId());
export const YEARS = createDropdownOption(UNIT_VALUES.year, 'Years', generateId());
